import { render, staticRenderFns } from "./VendorBoothImage.vue?vue&type=template&id=218a63db&"
import script from "./VendorBoothImage.vue?vue&type=script&lang=js&"
export * from "./VendorBoothImage.vue?vue&type=script&lang=js&"
import style0 from "./VendorBoothImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports